export default "__VITE_ASSET__B2_xnn3B__"